import { render } from "./FarmOSCreateDialog.vue?vue&type=template&id=58c3327e"
import script from "./FarmOSCreateDialog.vue?vue&type=script&lang=js"
export * from "./FarmOSCreateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__